module.exports = __webpack_public_path__ + "static/img/1.c17284e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/1.png
// module id = AEev
// module chunks = 0